export const config = {
  Main_Endpoint: process.env.REACT_APP_MAIN_API_URL,
};